import React from "react";
import NextImage from "../../common/NextImage";
import { convertDateTime, navigateToLeague } from "../../../utils/generalLiveCenter";


const LeagueHead = ({ league, updatedData, setDataType, setDataId, setHead, baseURL, matchType, websiteBaseUrl, dataClient, dataPath, design }) => {
    return (
        <>
            {matchType === "league" &&
                Array.isArray(league?.matches) &&
                league?.matches[0]?.competitors !== null && (
                    <div className="leg_head">
                        <h2>
                            {updatedData ? (
                                <span className="name">{league?.d}</span>
                            ) : (
                                <span className="name">{convertDateTime(league?.d)}</span>
                            )}
                        </h2>
                    </div>
                )}

            {league?.lid && (
                <div
                    className="leg_head"
                    style={{ cursor: "pointer" }}
                    onClick={() => navigateToLeague(league, dataClient, websiteBaseUrl, dataPath)}
                >
                    <div className="team_head">
                        <div className="league_logo">
                            <NextImage
                                src={`${baseURL}/public/assets/images/flags/country_${league?.fid}.png`}
                                height={23}
                                width={23}
                                alt="teamLogo"
                                priority={false}
                            />
                        </div>
                        <h2>
                            <span
                                className="name"

                            >
                                {league?.nm}
                            </span>
                        </h2>
                    </div>
                </div>
            )}
        </>
    );
};

export default LeagueHead;
